export const Footer = () => (
  <footer className="bg-gray-800 text-white py-8 md:py-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="text-xl font-extrabold text-teal-400 tracking-tight mb-2">
        Stedway<span className="text-orange-400">Tech</span>
      </div>
      <p className="text-gray-400 text-sm">&copy; {new Date().getFullYear()} StedwayTech. All rights reserved.</p>
    </div>
  </footer>
);